export default __webpack_public_path__ + "static/media/loading_unity_mobile.fb87b660.jpg";